export const mockServices = [
  {
    id: 'rpa',
    title: 'Robotic Process Automation',
    slug: 'robotic-process-automation',
    shortDesc: 'Eliminate manual bottlenecks and accelerate operations with intelligent automation that works 24/7.',
    description: 'Transform repetitive, rule-based tasks into automated workflows that reduce errors, cut processing time by up to 80%, and free your team to focus on strategic work. We design, deploy, and optimize RPA solutions tailored to your operational needs.',
    features: ['End-to-End Process Analysis', 'Bot Development & Deployment', 'Workflow Optimization', 'Continuous Performance Monitoring'],
    benefits: ['Up to 80% reduction in processing time', '99.5% accuracy with compliance built-in', 'Scalable automation infrastructure', 'ROI typically achieved within 6-12 months']
  },
  {
    id: 'erp-crm',
    title: 'ERP / CRM Solutions',
    slug: 'erp-crm-solutions',
    shortDesc: 'Unify operations and boost customer engagement with integrated ERP and CRM platforms.',
    description: 'We implement and customize enterprise systems that connect your business operations, eliminate data silos, and deliver real-time insights. From Microsoft Dynamics to Salesforce—we ensure seamless adoption and measurable ROI.',
    features: ['Platform Selection & Strategy', 'Custom Configuration & Integration', 'Data Migration with Zero Downtime', 'User Training & Adoption Support'],
    benefits: ['Single source of truth for business data', 'Enhanced customer insights and retention', 'Real-time reporting across departments', '40-60% improvement in operational efficiency']
  },
  {
    id: 'app-dev',
    title: 'Application Development',
    slug: 'application-development',
    shortDesc: 'Build scalable, modern applications that solve real business problems and drive growth.',
    description: 'From concept to launch, we deliver custom software solutions using modern technologies and agile methodologies. Whether you need web, mobile, or cloud-native applications—we build for performance, scalability, and long-term success.',
    features: ['Full-Stack Web Development', 'Native & Cross-Platform Mobile Apps', 'Cloud-Native Architecture', 'API Development & Third-Party Integration'],
    benefits: ['Solutions built for your unique workflows', 'Scalable architecture that grows with you', 'Modern tech stack with ongoing support', 'Faster time-to-market with agile delivery']
  },
  {
    id: 'staffing',
    title: 'IT Staffing Solutions',
    slug: 'it-staffing-solutions',
    shortDesc: 'Connect with pre-vetted IT professionals who match your technical needs and culture—fast.',
    description: 'Whether you need contract resources, permanent hires, or project-based teams—we deliver qualified IT talent within 72 hours. Our rigorous screening process ensures you get professionals with the right skills and cultural fit to drive results from day one.',
    features: ['Contract & Temporary Staffing', 'Permanent Placement', 'Project-Based Teams', 'Staff Augmentation & Consulting'],
    benefits: ['Qualified candidates within 72 hours', 'Pre-vetted technical and cultural fit', 'Flexible engagement models', 'Ongoing contractor management and support']
  },
  {
    id: 'ai-strategy',
    title: 'AI Strategy & Readiness Assessments',
    slug: 'ai-strategy-readiness-assessments',
    shortDesc: 'Build a clear AI roadmap aligned with business outcomes and realistic ROI projections.',
    description: 'Most organizations struggle to move AI from pilot to production. We help you identify high-impact use cases, assess your data and tech stack readiness, estimate realistic ROI, and build executable roadmaps that drive measurable business value.',
    features: ['Use-Case Discovery & Prioritization', 'ROI Modeling & Business Case Development', 'Data & Infrastructure Assessment', 'AI Roadmap & Governance Framework'],
    benefits: ['Clear path from strategy to execution', 'Data-backed ROI projections', 'Risk identification and mitigation', 'Alignment across technical and business teams']
  },
  {
    id: 'gen-ai-llm',
    title: 'Generative AI / LLM Implementation',
    slug: 'generative-ai-llm-implementation',
    shortDesc: 'Deploy enterprise-grade generative AI solutions that integrate seamlessly into your workflows.',
    description: 'Move beyond basic ChatGPT usage to custom LLM implementations that solve specific business challenges. We handle everything from model selection and fine-tuning to RAG systems, prompt engineering, and secure deployment—ensuring governance and scalability.',
    features: ['LLM Selection & Deployment', 'Custom Fine-Tuning & Prompt Engineering', 'RAG & Vector Database Implementation', 'AI Chatbots & Knowledge Management Systems'],
    benefits: ['30-50% productivity gains in knowledge work', 'Custom models trained on your domain', 'Enterprise-grade security and compliance', 'Seamless integration with existing tools']
  },
  {
    id: 'data-ml-ops',
    title: 'Data Engineering & ML Ops',
    slug: 'data-engineering-ml-ops',
    shortDesc: 'Build production-ready ML systems that scale from pilot to enterprise deployment.',
    description: 'Many AI initiatives fail at the production stage. We build end-to-end ML pipelines with automated deployment, monitoring, and retraining—ensuring your models deliver consistent value in production environments.',
    features: ['Data Pipeline Architecture & Automation', 'Feature Engineering & Management', 'Model Deployment & Orchestration', 'Performance Monitoring & Auto-Scaling'],
    benefits: ['Production-grade ML infrastructure', 'Automated model lifecycle management', 'Reduced deployment time by 70%', 'Scalable systems built for enterprise needs']
  },
  {
    id: 'ai-governance',
    title: 'AI Governance, Ethics & Risk Management',
    slug: 'ai-governance-ethics-risk-management',
    shortDesc: 'Deploy AI responsibly with frameworks that ensure compliance, fairness, and explainability.',
    description: 'As AI adoption grows, so do risks around bias, privacy, and regulatory compliance. We help you build governance frameworks that ensure responsible AI deployment—from bias detection to audit trails and explainable models.',
    features: ['AI Policy & Governance Framework Development', 'Bias Detection & Mitigation Strategies', 'Model Explainability & Audit Trails', 'Regulatory Compliance Management'],
    benefits: ['Reduced AI-related legal and reputational risk', 'Compliance with GDPR, CCPA, and industry standards', 'Transparent and auditable AI systems', 'Enhanced stakeholder trust and adoption']
  },
  {
    id: 'industry-ai',
    title: 'Industry-Specific AI Solutions',
    slug: 'industry-specific-ai-solutions',
    shortDesc: 'AI implementations designed for your industry\'s unique challenges and compliance requirements.',
    description: 'Generic AI solutions often fail in specialized industries. We combine deep domain expertise with AI capabilities to deliver solutions that understand your regulatory requirements, workflows, and industry-specific challenges—from healthcare diagnostics to financial risk modeling.',
    features: ['Domain-Expert AI Model Development', 'Industry Workflow Integration', 'Regulatory & Compliance Alignment', 'Specialized Use-Case Solutions'],
    benefits: ['Solutions built for industry-specific needs', 'Faster ROI with domain expertise', 'Compliance with sector regulations', 'Competitive differentiation through AI']
  },
  {
    id: 'ai-automation',
    title: 'AI-Powered Workflow Automation',
    slug: 'ai-powered-workflow-automation',
    shortDesc: 'Augment human capability with intelligent automation that learns and adapts.',
    description: 'Go beyond traditional RPA with AI-powered automation that handles unstructured data, makes decisions, and continuously improves. From intelligent document processing to AI-augmented customer service—we help you achieve measurable productivity gains without workforce disruption.',
    features: ['Intelligent Document Processing', 'AI-Augmented Decision Support', 'Natural Language Processing for Automation', 'Predictive Workflow Optimization'],
    benefits: ['30-50% productivity improvement', 'Handle complex, unstructured tasks', 'Continuous learning and optimization', 'Enhanced employee experience and retention']
  },
  {
    id: 'consulting',
    title: 'IT Consulting',
    slug: 'it-consulting',
    shortDesc: 'Strategic technology guidance that aligns IT investments with business outcomes.',
    description: 'Navigate complex technology decisions with confidence. Our consulting services help you modernize infrastructure, develop digital transformation strategies, and build technology roadmaps that deliver measurable business value while managing risk and cost.',
    features: ['Technology Assessment & Strategy', 'Digital Transformation Planning', 'Cloud Migration & Optimization', 'IT Roadmap & Budget Development'],
    benefits: ['Strategic alignment of IT and business goals', 'Risk mitigation and cost optimization', 'Faster decision-making with expert guidance', 'Competitive advantage through technology']
  },
  {
    id: 'eor',
    title: 'Employer of Record (EOR)',
    slug: 'employer-of-record',
    shortDesc: '100% compliant employment management without the overhead of setting up legal entities.',
    description: 'Hire talent across Canada and the U.S. without establishing local entities. We handle payroll, benefits, taxes, compliance, and HR administration—so you can focus on managing your team and delivering results.',
    features: ['Full Payroll & Benefits Administration', 'Tax Compliance & Reporting', 'HR & Employment Law Compliance', 'Risk Management & Insurance'],
    benefits: ['No legal entity setup required', '100% compliant with local regulations', 'Reduced administrative burden', 'Fast market entry and scaling']
  },
  {
    id: 'aor',
    title: 'Agent of Record (AOR)',
    slug: 'agent-of-record',
    shortDesc: 'Streamline contractor management with compliant onboarding, payments, and classification.',
    description: 'Manage independent contractors and contingent workers with confidence. We handle worker classification, compliance, contract administration, and payments—ensuring you stay audit-ready while reducing administrative complexity.',
    features: ['Worker Classification & Compliance', 'Contract Administration & Onboarding', 'Payment Processing & Tax Reporting', 'Compliance Monitoring & Auditing'],
    benefits: ['Eliminate misclassification risk', 'Simplified contractor payments', 'Audit-ready documentation', 'Transparent process and reporting']
  },
  {
    id: 'direct-sourcing',
    title: 'Direct Sourcing',
    slug: 'direct-sourcing',
    shortDesc: 'Build your own talent pool and reduce reliance on external agencies.',
    description: 'Create a curated talent community of pre-vetted professionals who know your organization. We help you build, manage, and engage your talent pool—reducing time-to-hire and agency costs while improving quality and retention.',
    features: ['Talent Pool Development & Curation', 'Candidate Engagement Programs', 'Applicant Tracking & Management', 'Performance Analytics & Insights'],
    benefits: ['50-70% reduction in agency spend', 'Faster time-to-fill for repeat roles', 'Higher quality and cultural fit', 'Direct relationship with talent']
  },
  {
    id: 'global-talent',
    title: 'Global Talent Solutions',
    slug: 'global-talent-solutions',
    shortDesc: 'Access specialized IT talent across borders without compliance complexity.',
    description: 'Tap into global talent markets to find niche skills and expertise. We handle international hiring, compliance, payroll, and benefits administration across Canada, the U.S., and select international markets.',
    features: ['International Talent Sourcing', 'Cross-Border Compliance Management', 'Global Payroll & Benefits', 'Immigration & Work Permit Support'],
    benefits: ['Access to specialized global skills', 'Compliant international hiring', 'Competitive cost advantages', 'Time zone coverage options']
  }
];

export const mockTeamMembers = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    role: 'Chief Executive Officer',
    bio: '15+ years leading technology transformations for Fortune 500 companies.'
  },
  {
    id: 2,
    name: 'James Chen',
    role: 'VP of Engineering',
    bio: 'Expert in building scalable systems and leading high-performance development teams.'
  },
  {
    id: 3,
    name: 'Maria Rodriguez',
    role: 'Director of RPA Solutions',
    bio: 'Specialized in process automation with 200+ successful RPA implementations.'
  },
  {
    id: 4,
    name: 'David Kumar',
    role: 'Head of Staffing',
    bio: 'Connected 1000+ IT professionals with leading companies across various industries.'
  }
];

export const mockTestimonials = [
  {
    id: 1,
    client: 'Jennifer Adams',
    company: 'Global Financial Services Inc.',
    role: 'CTO',
    text: 'genTechStaffing delivered an RPA solution that reduced our processing time by 75%. Their team understood our needs and delivered beyond expectations.',
    rating: 5
  },
  {
    id: 2,
    client: 'Michael Torres',
    company: 'HealthTech Solutions',
    role: 'Operations Director',
    text: 'The ERP implementation was seamless. Their expertise and support throughout the migration process was exceptional. Highly recommend their services.',
    rating: 5
  },
  {
    id: 3,
    client: 'Lisa Wang',
    company: 'E-Commerce Ventures Ltd.',
    role: 'CEO',
    text: 'Outstanding IT staffing partner. They provided us with talented developers who integrated perfectly with our team and delivered quality work.',
    rating: 5
  },
  {
    id: 4,
    client: 'Robert Jackson',
    company: 'Manufacturing Solutions Corp.',
    role: 'VP of Technology',
    text: 'Their consulting services helped us develop a clear technology roadmap. The strategic guidance was invaluable for our digital transformation.',
    rating: 5
  }
];

export const mockCaseStudies = [
  {
    id: 1,
    title: 'Financial Services Automation',
    client: 'Major Banking Institution',
    industry: 'Financial Services',
    challenge: 'Manual processing of 10,000+ loan applications monthly causing delays and errors.',
    solution: 'Implemented end-to-end RPA solution automating document verification, data extraction, and compliance checks.',
    results: ['80% reduction in processing time', '99.5% accuracy rate', '$2M annual cost savings', '95% customer satisfaction improvement']
  },
  {
    id: 2,
    title: 'Healthcare CRM Transformation',
    client: 'Regional Healthcare Network',
    industry: 'Healthcare',
    challenge: 'Fragmented patient data across multiple systems limiting care coordination.',
    solution: 'Deployed integrated CRM solution unifying patient records, appointment scheduling, and communication channels.',
    results: ['Unified patient view across 15 facilities', '40% improvement in appointment scheduling', '50% reduction in administrative overhead', 'Enhanced patient engagement']
  },
  {
    id: 3,
    title: 'E-Commerce Platform Development',
    client: 'Growing Retail Brand',
    industry: 'Retail',
    challenge: 'Legacy system unable to scale with business growth and market demands.',
    solution: 'Built cloud-native e-commerce platform with mobile apps, real-time inventory, and advanced analytics.',
    results: ['300% increase in transaction capacity', 'Mobile conversion rate up 45%', '99.9% uptime achieved', 'Seamless omnichannel experience']
  }
];

export const mockIndustries = [
  'Financial Services',
  'Healthcare',
  'Retail & E-Commerce',
  'Manufacturing',
  'Technology',
  'Telecommunications',
  'Insurance',
  'Education'
];